import { TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';
var RevisorComponent = /** @class */ (function () {
    function RevisorComponent(fb, _userService, rutValidator, dialog, spinner) {
        this.fb = fb;
        this._userService = _userService;
        this.rutValidator = rutValidator;
        this.dialog = dialog;
        this.spinner = spinner;
        this.rows = [];
        this.matcher = new FormService();
        this.nombreComuna = new FormControl('', [Validators.required]);
        this.options = [];
        this.selectedRev = null;
        this.rut_ind = this.fb.group({
            rut: ['', [Validators.required, this.rutValidator]]
        });
        if (!JSON.parse(localStorage.getItem("revisor"))) {
            localStorage.setItem("revisor", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("revisor"));
        }
        this.invalidRut = true;
        this.revisor = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', recordId: '' };
    }
    RevisorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getComunas();
        this.filteredOptions = this.nombreComuna.valueChanges
            .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
    };
    RevisorComponent.prototype._filter = function (value) {
        var filterValue = value.toLowerCase();
        return this.options.filter(function (option) { return option.toLowerCase().includes(filterValue); });
    };
    RevisorComponent.prototype.get_revisor = function (rut) {
        var _this = this;
        this.spinner.show();
        this.cleanData();
        this._userService.getRevisor(rut).subscribe(function (response) {
            if (response.message) {
                _this.revisor.rut = rut ? rut : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
            }
            else {
                _this.revisor.rut = response.rut ? response.rut : '';
                _this.revisor.nombre = response.nombre ? response.nombre : '';
                _this.revisor.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                _this.revisor.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                _this.revisor.direccion = response.direccion ? response.direccion : '';
                _this.revisor.direccion_num = response.direccion_num ? response.direccion_num : '';
                _this.revisor.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                _this.revisor.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                _this.revisor.comuna = response.comuna ? response.comuna : '';
                _this.revisor.fono = response.fono ? response.fono : '';
                _this.revisor.fax = response.fax ? response.fax : '';
                _this.revisor.mail = response.mail ? response.mail : '';
                _this.revisor.patente = response.patente ? response.patente : '';
                _this.revisor.registro = response.registro ? response.registro : '';
                _this.revisor.categoria = response.categoria ? response.categoria : '';
                _this.revisor.recordId = response.recordId ? response.recordId : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
                console.log(_this.revisor);
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    RevisorComponent.prototype.cleanData = function () {
        this.revisor = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', registro: '', categoria: '', recordId: '' };
        this.rut_ind.reset();
    };
    RevisorComponent.prototype.update_revisor = function (rut, id) {
        this.get_revisor(rut);
        this.selectedRev = id;
    };
    RevisorComponent.prototype.saverevisor = function () {
        var _this = this;
        window.scroll(0, 0);
        //elimina la fila si escriben un rut que ya esté ingresado
        for (var x = 0; x < this.rows.length; x++) {
            if (this.revisor.rut == this.rows[x].rut) {
                this.delete_revisor(x);
            }
        }
        //elimina fila cuando la editan
        /*if (this.selectedRev != null) {
            this.delete_revisor(this.selectedRev);
            this.selectedRev = null;
        }*/
        this.spinner.show();
        this._userService.saveRevisor(this.revisor).subscribe(function (response) {
            _this.spinner.hide();
            console.log(response);
            if (response.update || response.save) {
                $("#ind_modal").modal("hide");
                _this.actualRow = localStorage.getItem("revisor");
                _this.rows = JSON.parse(_this.actualRow);
                _this.rows = _this.rows.concat({
                    rut: _this.revisor.rut,
                    nombre: _this.revisor.nombre,
                    apellido_mat: _this.revisor.apellido_mat,
                    apellido_pat: _this.revisor.apellido_pat,
                    direccion: _this.revisor.direccion,
                    direccion_num: _this.revisor.direccion_num,
                    direccion_complemento: _this.revisor.direccion_complemento,
                    direccion_completa: _this.revisor.direccion_completa,
                    comuna: _this.revisor.comuna,
                    fono: _this.revisor.fono,
                    fax: _this.revisor.fax,
                    mail: _this.revisor.mail,
                    patente: _this.revisor.patente,
                    registro: _this.revisor.registro,
                    categoria: _this.revisor.categoria
                });
                localStorage.setItem("revisor", JSON.stringify(_this.rows));
                _this.revisor = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', registro: '', categoria: '', recordId: '' };
                _this.rut_ind.reset();
                _this.dialog.closeAll();
            }
        }, function (error) {
            _this.spinner.hide();
            console.log(error);
        });
    };
    RevisorComponent.prototype.delete_revisor = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("revisor", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('revisor'));
            }
        }
    };
    RevisorComponent.prototype.getComunas = function () {
        var _this = this;
        this._userService.getComunas().subscribe(function (res) {
            //console.log('res', res);
            for (var i = 0; i < res.length; i++) {
                _this.options.push(res[i].fieldData.COM_Nombre);
            }
            _this.filteredOptions = _this.nombreComuna.valueChanges
                .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
        }, function (error) {
            console.log(error);
        });
    };
    return RevisorComponent;
}());
export { RevisorComponent };
